(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Match the photo to the height of the closed question list, and keep it there when answers open.
  var grid = document.querySelector('[data-faq]');
  if (!grid) return;
  var list = grid.querySelector('[data-faq-list]');
  var photo = grid.querySelector('[data-faq-photo]');
  if (!list || !photo) return;
  function size() {
    var open = list.querySelectorAll('details[open]');
    open.forEach(function (d) { d.open = false; });
    photo.style.setProperty('--faq-h', list.offsetHeight + 'px');
    open.forEach(function (d) { d.open = true; });
  }
  size();
  window.addEventListener('resize', size);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shelf-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-shelf]');
  if (!root) return;
  root.setAttribute('data-js', '');
  var tabs = root.querySelectorAll('.stab');
  var items = root.querySelectorAll('.shelf-item');
  var empty = root.querySelector('[data-empty]');
  var title = root.querySelector('[data-shelf-title]');
  var desc = root.querySelector('[data-shelf-desc]');
  function show(handle) {
    var current = null;
    tabs.forEach(function (t) { if (t.getAttribute('data-tab') === handle) current = t; });
    if (!current) return;
    var count = 0;
    items.forEach(function (it) {
      var ok = handle === 'all' || (it.getAttribute('data-cats') || '').indexOf(' ' + handle + ' ') !== -1;
      it.hidden = !ok;
      if (ok) count++;
    });
    if (empty) empty.hidden = count !== 0;
    tabs.forEach(function (t) { t.setAttribute('aria-pressed', t === current ? 'true' : 'false'); });
    if (title) title.textContent = current.getAttribute('data-title');
    var d = current.getAttribute('data-desc');
    if (desc) { desc.textContent = d; desc.hidden = !d; }
  }
  tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-tab')); }); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-shelf-tab]');
    if (a) show(a.getAttribute('data-shelf-tab'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-all"] && !Shopify.designMode) return;
  try {
    
(function () {
  var box = document.querySelector('[data-sa-filters]');
  var grid = document.querySelector('[data-sa-grid]');
  if (!box || !grid) return;
  box.setAttribute('data-js', '');
  var checks = box.querySelectorAll('input[type=checkbox]');
  var items = grid.querySelectorAll('.sa-item');
  var empty = document.querySelector('[data-sa-empty]');
  var count = box.querySelector('[data-sa-count]');
  // Within one group a product matches any ticked option; across groups it must match every group.
  function apply() {
    var groups = {};
    var n = 0;
    checks.forEach(function (c) {
      if (!c.checked) return;
      var k = c.getAttribute('data-key');
      (groups[k] = groups[k] || []).push(c.value);
      n++;
    });
    var shown = 0;
    items.forEach(function (it) {
      var ok = Object.keys(groups).every(function (k) {
        var have = it.getAttribute('data-' + k) || '';
        return groups[k].some(function (v) { return have.indexOf('|' + v + '|') !== -1; });
      });
      it.hidden = !ok;
      if (ok) shown++;
    });
    if (empty) empty.hidden = shown !== 0;
    if (count) { count.hidden = n === 0; count.textContent = n; }
  }
  checks.forEach(function (c) { c.addEventListener('change', apply); });
  box.querySelector('[data-sa-clear]').addEventListener('click', function () { checks.forEach(function (c) { c.checked = false; }); apply(); });
  box.querySelector('[data-sa-done]').addEventListener('click', function () { box.open = false; });
  document.addEventListener('click', function (e) { if (box.open && !box.contains(e.target)) box.open = false; });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.open = false; });
})();

  } catch(e) { console.error(e); }
})();
})();
